import { motion } from "framer-motion";
import {
  Lightning,
  Target,
  LockKey,
  Users,
  Clock,
  Handshake,
} from "@phosphor-icons/react";

const icons = [Lightning, Target, LockKey, Users, Clock, Handshake];

export default function WhyChooseUs({ t }) {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative py-24 md:py-32"
      style={{ background: "#050505" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-sm uppercase tracking-[0.2em] text-[#00F0FF] font-semibold mb-4 block font-chivo">
            {t.whyUs.overline}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-white font-outfit">
            {t.whyUs.title}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.whyUs.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.08, duration: 0.5 }}
                data-testid={`why-card-${i}`}
                className="group relative bg-white/[0.03] border border-white/10 rounded-2xl p-6 hover:border-[#00F0FF]/30 transition-all duration-300 hover:bg-white/[0.05]"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-[#0055FF]/15 flex items-center justify-center flex-shrink-0 group-hover:bg-[#00F0FF]/15 transition-colors">
                    <Icon size={22} weight="duotone" className="text-[#00F0FF]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-1 font-outfit">
                      {item.title}
                    </h3>
                    <p className="text-sm text-[#94A3B8] font-chivo leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
